/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var ScaffoldView = require('./views/ScaffoldView');
var scaffoldView = new ScaffoldView();

// Set scroll position to top of page anytime a new view is show in the content
// region of the scaffold view
scaffoldView.getRegion('content').on('swapOut', function() {
  window.scrollTo(0, 0);
});

scaffoldView.render();

module.exports = scaffoldView;
